import { render, staticRenderFns } from "./DetectionDetailHistoryLayout.vue?vue&type=template&id=b8d02e00&scoped=true"
import script from "./DetectionDetailHistoryLayout.vue?vue&type=script&lang=js"
export * from "./DetectionDetailHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d02e00",
  null
  
)

export default component.exports